module.exports = __webpack_public_path__ + "img/runPie_bg.37ea3d08.png";